import { Id } from "@dgs/core";

export const projectKeys = {
	all: ["projects"] as const,
	lists: () => [...projectKeys.all, "lists"] as const,
	details: () => [...projectKeys.all, "detail"] as const,
	detail: (id: Id) => [...projectKeys.details(), `${id}`],
	overview: (id: Id) => [...projectKeys.detail(id), "overview"],
};
